import webBiLogger from '@wix/web-bi-logger';
import { useCallback } from 'react';

import { LogBI } from '../types';
import { useSessionBI } from './useSessionBI';
import {
  getClientIdOrGenerate,
  getWixClientId,
  setWixClientId,
} from '../utils/login';
import { useStore } from '../zustand/stores';

const WIX_CLIENT_ID_REGEX =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;

const shouldSetWixClientId = (
  cookieClientId: string | undefined,
  serverClientId: string | undefined
) => {
  if (!cookieClientId) {
    return true;
  }
  return serverClientId !== undefined && !WIX_CLIENT_ID_REGEX.test(cookieClientId);
};

export const useBI = () => {
  const { getSessionBI } = useSessionBI();
  const { loggedInAccountId } = useStore((state) => state.userSlice);
  const serverClientId = useStore((state) => state.biSlice.clientId);
  const sendBIEvent = useCallback(
    async (event: LogBI): Promise<void> => {
      if (shouldSetWixClientId(getWixClientId(), serverClientId)) {
        setWixClientId(serverClientId);
      }

      const biLogger = webBiLogger
        .factory()
        .withNonEssentialContext({
          clientId: getClientIdOrGenerate(),
        })
        .logger();
      getSessionBI(event)
        .then(async (value) => {
          if (value) {
            event.params.self_service_session_id = value;
          }
          if (loggedInAccountId) {
            event.params.target_account_id = loggedInAccountId;
          }
          await biLogger.report(event);
        })
        .catch(() => biLogger.report(event));
    },
    [getSessionBI, loggedInAccountId, serverClientId]
  );

  return { sendBIEvent };
};
